import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";
import { supabase } from "../../../lib/supabase";
import { deleteFromFtp } from "../../../lib/deleteFromFtp";
import { formatPrice } from "../../../lib/formatPrice";

interface BoatItem {
  id: string;
  Title: string;
  CatalogImage: string;
  Price?: string;
}

const BoatList: React.FC = () => {
    const navigate = useNavigate();
    const [boats, setBoats] = useState<BoatItem[]>([]);
    
    const fetchBoats = async () => {
        const { data, error } = await supabase.from('boats').select('*');
        if (error) {
            console.error(error);
        } else {
            setBoats(data as BoatItem[]);
        }
    }

    useEffect(() => {
        fetchBoats();
    }, []);

    const handleDelete = async (id: string) => {
        if(!window.confirm("Bu tekneyi silmek istediğinize emin misiniz?")) return;
        
        const itemToDelete = boats.find(b => b.id === id) as any;

        try {
            const { error } = await supabase.from('boats').delete().eq('id', id);
            if (!error) {
                // Delete associated files from FTP
                if (itemToDelete) {
                    if (itemToDelete.CatalogImage) deleteFromFtp(itemToDelete.CatalogImage);
                    if (Array.isArray(itemToDelete.Images)) {
                        itemToDelete.Images.forEach((img: string) => deleteFromFtp(img));
                    }
                    if (Array.isArray(itemToDelete.Videos)) {
                        itemToDelete.Videos.forEach((vid: any) => {
                            if (vid.url) deleteFromFtp(vid.url);
                        });
                    }
                }
                fetchBoats();
            } else {
                console.error(error);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">Tekne Yönetimi</h1>
                <Link to="/panel/boats/add" className="bg-blue-600 text-white px-4 py-2 rounded flex items-center">
                    <Plus className="mr-2" /> Yeni Tekne Ekle
                </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {boats.map(boat => (
                    <div 
                        key={boat.id} 
                        onClick={() => navigate(`/panel/boats/edit/${boat.id}`)}
                        className="bg-white p-4 rounded shadow flex flex-col relative group cursor-pointer hover:shadow-lg transition-shadow"
                    >
                        <img src={boat.CatalogImage} alt={boat.Title} className="w-full h-40 object-cover rounded mb-4"/>
                        <h3 className="font-bold text-lg">{boat.Title}</h3>
                        <p className="text-green-600 font-bold">{boat.Price ? `${formatPrice(boat.Price)} ₺` : "Fiyat Belirtilmemiş"}</p>
                        
                        <button 
                            onClick={(e) => { e.stopPropagation(); handleDelete(boat.id); }} 
                            className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BoatList;
